import { colors, Input, FormControl } from '@spaceshipapp/cambridge';
import styled from 'styled-components';

export const FormWrapper = styled.form`
  width: 500px;
  margin: 1rem;
  position: relative;
  background: ${colors.surface};
  border-radius: 8px;
  padding: 25px;
`;

export const Header = styled.div`
  display: flex;
  margin-top: 1rem;
  padding-top: 2rem;
  padding-bottom: 0.5rem;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  border-top: 0.2rem solid;
  color: ${colors.subtext};
  font-weight: 500;
`;

export const Footer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 25px;
  align-items: center;
  justify-content: space-between;
`;
export const ErrorMessage = styled.div`
  display: relative;
  width: 100%;
  height: 1rem;
  font-size: 1rem;
  margin-bottom: 1rem;
  color: red;
`;
export const LoginInput = styled(Input)`
  display: relative;
  width: 100%;
`;

export const LoginFormControl = styled(FormControl)`
  display: relative;
  width: 100%;
  margin-bottom: 1rem;
`;
